import * as React from 'react';
const FileInput = ({ disabled = false, id, label, name, onChange, }) => (React.createElement("div", { className: "tk-input-group" },
    React.createElement("div", { className: "tk-input-group__header" }, label ? (React.createElement("label", { className: "tk-label", htmlFor: id }, label)) : ''),
    React.createElement("div", { className: "tk-input__container" },
        React.createElement("input", { className: "tk-input", disabled: disabled, id: id, name: name, onChange: onChange, type: "file" }))));
export default FileInput;
